
let masonryInstances = {};

function initMasonry($content) {
    const $grid = $content.find('.masonry-grid');
    if (!$grid.length) return;

    // Initially hide the grid
    $grid.css({
        visibility: 'hidden',
        opacity: 0
    });

    // Assign unique ID to each grid
    if (!$grid[0].dataset.masonryId) {
        $grid[0].dataset.masonryId = 'masonry-' + Math.random().toString(36).substr(2, 9);
    }
    const id = $grid[0].dataset.masonryId;

    // Wait for images to load
    imagesLoaded($grid[0], function () {
        if (!masonryInstances[id]) {
            masonryInstances[id] = new Masonry($grid[0], {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                gutter: 16,
                percentPosition: true
            });
        } else {
            masonryInstances[id].layout();
        }

        // After Masonry layout is complete, make the grid visible
        $grid.css({
            visibility: 'visible',
            opacity: 1
        });
    });
}

$(document).ready(function () {
    $('.accordion-header').click(function () {
        const $content = $(this).next('.accordion-content');

        // Close other accordion items
        $('.accordion-content').not($content).slideUp();

        // Open the clicked accordion section
        if (!$content.is(':visible')) {
            $content.slideDown(300, function () {
                // Delay to allow final height
                setTimeout(() => {
                    initMasonry($content); // Initialize Masonry after content is visible
                }, 20);
            });
        } else {
            $content.slideUp();
        }
    });
});

// Initialize lightbox for images
var $gallery = new SimpleLightbox('.masonry-grid .grid-item a', {});
